import { render } from "./InclusionResourcesTestReport.vue?vue&type=template&id=77b1e784&scoped=true&ts=true"
import script from "./InclusionResourcesTestReport.vue?vue&type=script&lang=ts"
export * from "./InclusionResourcesTestReport.vue?vue&type=script&lang=ts"

import "./InclusionResourcesTestReport.vue?vue&type=style&index=0&id=77b1e784&scoped=true&lang=css"
import "./InclusionResourcesTestReport.vue?vue&type=style&index=1&id=77b1e784&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b1e784"]])

export default __exports__